import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faList, faMagicWandSparkles } from '@fortawesome/pro-light-svg-icons'

import { Box, Button } from '@domain-group/suit-theme'

import { useSetState } from '@domain-group/react-hooks'

import useReporting from '@hooks/useReporting'

import handleCallbackAction from '@functions/handleCallbackAction'

import type {
  UsePublicationBookingPlannerPayload,
} from '@components/PublicationBookingPlanner/hooks/usePublicationBookingPlanner'

import type { UsePublicationOrderPayload } from '@hooks/usePublicationOrder'

import Items from './Items'
import PublicationOrderStatus from './PublicationOrderStatus'

const confirmAction = (autoPaginateFn: UsePublicationOrderPayload['callbacks']['autoPaginate']) => {
  const requestOptions = {
    include_artwork_preview: true,
    include_publication_booking_item_artwork: true,
    include_publication_booking_item_grid: true,
    include_publication_booking_items: true,
    include_publication_booking_publication_product: true,
    include_publication_booking_space: true,
    include_publication_booking_status: true,
    include_publication_order_bookings: true,
  }

  const autoPaginatePayload = {
    callbacks: {
      action: autoPaginateFn,
    },
    entityParams: {},
    requestOptions,
    toastText: 'Auto Paginate',
  }

  swal.fire({
    confirmButtonColor: '#43AC6A',
    confirmButtonText: 'Yes, paginate now.',
    icon: 'success',
    showCancelButton: true,
    text: 'Are you sure? This will remove all current bookings.',
    title: 'Auto Paginate?',
  }).then(({ value }) => {
    if (value){
      // @ts-expect-error TS2345
      handleCallbackAction(autoPaginatePayload)
    }
  })
}
interface LeftSidebarProps {
  bookingPlannerPayload: UsePublicationBookingPlannerPayload,
}

const LeftSidebar = (props: LeftSidebarProps) => {
  const {
    bookingPlannerPayload,
    bookingPlannerPayload: {
      callbacks: {
        autoPaginate,
        showCreateCampaignPublicationOrderModal,
      },
      editionData: {
        isBooked,
      },
      publicationEditionPayload: {
        publicationEdition: {
          id: publicationEditionId,
        },
      },
    },
  } = props

  const useReportingPayload = useReporting({
    allowedReports: ['publication_edition_orders'],
    defaultValues: { publication_edition_id: publicationEditionId },
    formDeps: [publicationEditionId],
  })

  const { callbacks: { generateReport: generateFn } } = useReportingPayload

  const generateReportPayload = {
    callbacks: {
      action: generateFn,
    },
    toastText: 'Report Queued',
  }

  const defaultState = { detailMode: false }

  const [state, setState] = useSetState(defaultState)
  const { detailMode } = state

  return (
    <Box
      borderRight="1px solid"
      borderColor="lineColor"
      flexDirection="column"
      height="100%"
      left="0"
      position="fixed"
      top="0"
      width="320px"
      zIndex="11"
    >
      <Box
        alignItems="center"
        borderBottom="1px solid"
        borderColor="lineColor"
        padding="large"
        height="70px"
      >
        <Button
          // @ts-expect-error
          border="1px solid"
          buttonStyle="primaryCreate"
          onClick={showCreateCampaignPublicationOrderModal}
          size="medium"
        >
          Create New Ad
        </Button>
      </Box>

      <Box
        flexDirection="column"
        height="calc(100% - 140px)" // Remove sidebar header and footer height
        padding="large"
      >
        <Box flexDirection="column" style={{ gap: '4px' }}>
          <Button
            buttonStyle="secondaryUtility"
            disabled={isBooked}
            icon={<FontAwesomeIcon icon={faMagicWandSparkles} />}
            // @ts-expect-error TS2345
            onClick={() => confirmAction(autoPaginate)}
            size="medium"
          >
            Auto Place Ads
          </Button>

          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faFileExcel} />}
            // @ts-expect-error TS2345
            onClick={() => handleCallbackAction(generateReportPayload)}
            size="medium"
          >
            Download Report
          </Button>

          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faList} />}
            onClick={() => setState({ detailMode: !detailMode })}
            size="medium"
          >
            Show Item Detail
          </Button>
        </Box>

        <Items bookingPlannerPayload={bookingPlannerPayload} detailMode={detailMode} />

        <PublicationOrderStatus bookingPlannerPayload={bookingPlannerPayload} />
      </Box>
    </Box>
  )
}

export default LeftSidebar
